@use "../../../../../../src/styles/Constants.scss" as Constants;

.filePreview {
	display: flex;
	flex-direction: row;
	align-items: end;
	gap: Constants.$val-spacing-m;
}

.preview:hover {
	cursor: pointer;
}
